import { createContext, useContext } from "react"

/**
 * MangoPay SCA ControlStatusEnum
 *
 * TODO: The following state is also possible but not documented: PENDING_VALIDATION
 * DOCS: https://docs.mangopay.com/guides/sca/session#6-receive-the-user-on-return
 */
export enum ControlStatusEnum {
	VALIDATED = "VALIDATED",
	FAILED = "FAILED",
}

export type ControlStatus = ControlStatusEnum

export interface HiddenGetParamsContextType {
	next?: string
	controlStatus?: ControlStatus
}

export const HiddenGetParamsContext = createContext<HiddenGetParamsContextType>(
	null!,
)

export const useHiddenGetParamsContext = () =>
	useContext(HiddenGetParamsContext)
